<template>
  <div v-if="!loading && haveAccount && !loadTranslation">
    <AppSidebar ref="sidebar" @burger-toggle="burgerClose"></AppSidebar>

    <section class="mobile-header">
      <img v-if="whitelabel" :src="orgLogo" class="orgLogo" />
      <a v-else class="logo" href="/dashboard">
        <CdnLogoByLang class="logo" />
      </a>
    </section>

    <div @click="sidebarToggle" role="button" class="burger" :class="{ open: isBurgerOpen }">
      <div class="burger__bar"></div>
      <div class="burger__bar"></div>
      <div class="burger__bar"></div>
    </div>

    <my-top-curved-bg />

    <NewDashboardBanner />
    <div
      class="wrapper-home"
      :class="{
        'wrapper-home--no-margins': $route.name === 'tickets-new',
        'wrapper-home--custom-reports': $route.path === '/reports/custom',
      }"
      v-if="!loadingAccess"
    >
      <transition name="fade">
        <router-view></router-view>
      </transition>
      <SmartupIframe />
    </div>
  </div>

  <div v-else-if="needSelectOrg" class="select-organizations-wrapper">
    <AppSidebar :need-select-org="needSelectOrg" ref="sidebar" @burger-toggle="burgerClose" />

    <div class="select-organizations" v-if="organizations.length > 0">
      <h4>
        {{ $t("template.select_organization") }}
      </h4>

      <div
        class="select-organization"
        @click="changeOrganization(org.id)"
        v-for="org in organizations"
        :key="org.id"
      >
        <p>{{ org.attributes.name }}</p>
      </div>
    </div>

    <div v-else class="select-organizations">
      <h4>
        {{ $t("template.you_dont_have_organization") }}
      </h4>

      <div class="tw-flex tw-flex-wrap tw-gap-4 tw-my-[20px]">
        <button
          type="button"
          @click.prevent="openModalAdd()"
          class="bttn bttn--lg bttn--orange"
          name="button"
        >
          {{ $t("account.add_organization") }}
        </button>
        <div class="tw-flex tw-flex-wrap tw-gap-4">
          <button
            type="button"
            @click.prevent="logout()"
            class="bttn bttn--lg bttn--blue bttn--logout"
            name="button"
          >
            {{ $t("template.signout") }}
          </button>
          <button
            v-if="previousRoute !== '/'"
            type="button"
            @click.prevent="() => $router.go(-1)"
            class="bttn bttn--lg bttn--blue"
            name="button"
          >
            {{ $t("template.back") }}
          </button>
        </div>
      </div>

      <add-organization ref="modalAddOrganization"> </add-organization>
    </div>
  </div>
</template>

<script>
import AppSidebar from "@/components/menu.vue";
import { mapState } from "vuex";
import addOrganization from "@/views/account/subcomponents/addOrganization.vue";
import SmartupIframe from "@/components/smartup-iframe.vue";
import myTopCurvedBg from "@/views/my-contacts/ui/my-top-curved-bg.vue";
import NewDashboardBanner from "@/components/new-dashboard-banner.vue";
import CdnLogoByLang from "@/common-components/cdn-v2/cdn-logo-by-lang.vue";

export default {
  name: "home",
  data() {
    return {
      isBurgerOpen: false,
      isDesktop: false,
      previousRoute: null,
    };
  },

  components: {
    AppSidebar,
    addOrganization,
    SmartupIframe,
    myTopCurvedBg,
    NewDashboardBanner,
    CdnLogoByLang,
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$data.previousRoute = from.path;
    });
  },

  computed: mapState({
    loading: (state) => {
      return state.account.loadingAccount;
    },

    needSelectOrg: (state) => {
      return state.account.needSelectOrg;
    },

    loadTranslation: (state) => {
      return state.translation.loadTranslation;
    },

    haveAccount: (state) => {
      return state.account.account;
    },

    loadingAccess: (state) => {
      return state.account.loadingAccess;
    },

    organizations: (state) => {
      return state.account.organizations;
    },

    whitelabel: (state) => (state.account.settings ? state.account.settings.whitelabel : false),

    orgLogo() {
      if (this.whitelabel) {
        return this.haveAccount.data.attributes.logo;
      }
      return false;
    },
  }),

  methods: {
    logout: function () {
      this.$store.dispatch("unsetUser");
      this.$router.push({ path: "/" });
    },

    openModalAdd: function () {
      this.$refs.modalAddOrganization.openModal();
    },

    sidebarToggle() {
      this.isBurgerOpen = !this.isBurgerOpen;
      this.$refs.sidebar.toggleSidebar();
    },

    burgerClose() {
      this.isBurgerOpen = false;
    },

    changeOrganization: function (id) {
      this.$store.dispatch("changeOrganization", id);
    },
  },

  created: function () {
    this.$store.dispatch("getAccountInfo");
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_vars.scss";

.mobile-header {
  height: 90px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $bb-90;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 50;
  @media only screen and (min-width: 1280px) {
    display: none;
  }
  > .logo {
    display: inline-block;
    margin: 0;
    svg {
      max-height: 60px;
      ::v-deep path {
        fill: white;
      }
    }
  }
}

.orgLogo {
  width: 70px;
  border-radius: 50%;
}

.burger {
  width: 24px;
  height: 24px;
  position: fixed;
  top: calc(45px - 9px);
  left: 15px;
  z-index: 150;
  cursor: pointer;
  @media only screen and (min-width: 1280px) {
    display: none;
  }
  &__bar {
    width: 21px;
    height: 4px;
    border-radius: 2px;
    background-color: #ffffff;
    position: relative;
    transition: all 0.2s ease-in-out;
    &:not(:last-of-type) {
      margin-bottom: 3px;
    }
  }
  &.open {
    .burger__bar {
      &:nth-of-type(1) {
        top: 7px;
        transform: rotate(-45deg);
      }
      &:nth-of-type(2) {
        opacity: 0;
        visibility: hidden;
      }
      &:nth-of-type(3) {
        bottom: 7px;
        transform: rotate(45deg);
      }
    }
  }
}

.wrapper-home {
  padding: 120px 15px;
  min-height: 100vh;
  background: url("https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/charidy_images/donor_dashboard/deco1.svg")
      top center no-repeat,
    url("https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/charidy_images/donor_dashboard/deco2.svg")
      top 0px right -10px no-repeat,
    url("https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/charidy_images/donor_dashboard/deco3.svg")
      bottom -100px right 0 no-repeat,
    url("https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/charidy_images/donor_dashboard/deco4.svg")
      bottom 100px left 0 no-repeat;
  @media only screen and (min-width: 1280px) {
    padding: 60px 70px 60px 70px;
    margin-left: 300px;
  }
}

.wrapper-home--no-margins {
  padding: 120px 0 0;
  background: none;

  @media only screen and (min-width: 1280px) {
    padding: 0;
  }
}

.wrapper-home--custom-reports {
  padding: 104px 10px 16px;
  box-sizing: border-box;
  min-height: 100vh;
  height: 100vh;
  min-height: 100dvh;
  height: 100dvh;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 1280px) {
    padding: 36px 24px 18px;
  }
}

.select-organizations {
  width: 80%;
  background: #fff;
  border-radius: 5px;
  padding: 50px;
  box-shadow: 1px 1px 14px -2px rgba(0, 0, 0, 0.15);
  @media only screen and (max-width: 540px) {
    width: 90%;
  }
  .select-organization {
    cursor: pointer;
    border-bottom: 1px solid #e7e7e7;
    padding: 20px 20px 0 20px;
    transition: all 0.5s;
    &:hover {
      border-color: #20434e;
    }
  }
}

.select-organizations-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;

  @media only screen and (min-width: 1280px) {
    margin-left: 300px;
  }
}

.add-organization-wrapp {
  display: flex;
}

.bttn--logout {
  @media screen and (min-width: 1280px) {
    display: none !important;
  }
}
</style>
